module.exports = __webpack_public_path__ + "img/banner.df7ee5d3.png";